import { Offer } from '../../../models/offer.model';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { SnackbarService } from '../../../services/shared/snackbar/snackbar.service';
import { TranslationService } from '../../../services/translation/translation.service';
import { UtilsService } from '../../../services/shared/utils/utils.service';

@Component({
  selector: 'app-add-offer-modal',
  templateUrl: './add-offer-modal.component.html',
  styleUrl: './add-offer-modal.component.css'
})
export class AddOfferModalComponent {
  isEmptyCode: boolean = false;
  codeExists: boolean = false;
  updated: boolean = false;

  name: string = "";
  code: string = "";
  listCodes: string[] = [];
  isRequired: boolean = true;
  hidden: boolean = false;
  expirationDelay: number | undefined;

  constructor(public dialogRef: MatDialogRef<AddOfferModalComponent>, @Inject(MAT_DIALOG_DATA) public data: { codes: string[] }, private formBuilder: FormBuilder, private snackBar: SnackbarService, public translationService: TranslationService, public utils: UtilsService) {
    this.listCodes = data.codes;
  }

  ngOnInit(): void {

  }

  onChangeCode(){
    setTimeout(() => {
      this.code = this.utils.updateTextProperty(this.code, "", /^[a-zA-Z0-9_]+$/, /[^A-Z0-9_]/g);
      this.isEmptyCode = this.code == "";
      this.codeExists = this.listCodes.includes(this.code);
      this.updated = true;
    }, 0);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.code.toUpperCase().replaceAll(' ','');
    if (!this.codeExists && !this.isEmptyCode) {
      const offer: Offer = {
        name: this.name,
        code: this.code,
        pages: [],
        isRequired: this.isRequired,
        hidden: this.hidden,
        expirationDelay: this.expirationDelay
      };

      this.dialogRef.close(offer);
    } else{
      this.snackBar.showError(this.translationService.translate('The code is invalid. Only alphanumeric characters and underscores are allowed.'));
    }
  }
}
